import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { CustomAvatar } from '@europrocurement/flexy-components';
import { GroupeTravailUtilisateurApiObject } from '@europrocurement/l2d-domain';

export type WorkGroupHeaderProps = {
    workgroup: GroupeTravailUtilisateurApiObject;
    isActiveStatus: boolean;
};

export const WorkGroupHeader: React.FunctionComponent<WorkGroupHeaderProps> = function ({
    workgroup,
    isActiveStatus,
}) {
    return (
        <Box
            display="flex"
            sx={{ margin: '0px 0px 18px 0px' }}
        >
            <CustomAvatar
                firstName={workgroup.lib}
                lastName=""
                sx={{ width: 64, height: 64, borderRadius: '50px' }}
            />
            <Box
                display="flex"
                flexDirection="column"
                sx={{ marginLeft: '15px' }}
            >
                <Typography
                    variant="l2dh5"
                    sx={{ lineHeight: '1.4' }}
                >
                    {`${workgroup.lib}`}

                    {isActiveStatus ? (
                        <Chip
                            sx={{ marginLeft: '8px' }}
                            color="primary"
                            label="Groupe actif"
                        />
                    ) : (
                        <Chip
                            sx={{ marginLeft: '8px' }}
                            color="default"
                            label="Groupe cl&ocirc;turé"
                        />
                    )}
                </Typography>
                <Typography
                    sx={{ lineHeight: '2' }}
                    variant="l2dbodys"
                    color="text.gris70"
                >
                    <b>Référent : </b>
                    {workgroup.iduserReferent
                        ? `${workgroup.iduserReferent.prenom} ${workgroup.iduserReferent.nom}`
                        : 'non défini'}
                </Typography>
            </Box>
        </Box>
    );
};
export default WorkGroupHeader;
